/**
 * User context for OpenTelemetry telemetry
 *
 * Stores user UUID and IP address that will be added to all traces and logs.
 * Similar to Vue's implementation in x-frontend-vue3/packages/www-main/src/utils/telemetry/user.ts
 */

let userUuid: string | null = null;
let userIp: string | null = null;

export const setUser = ({
  uuid,
  ip,
}: {
  uuid?: string | null;
  ip?: string | null;
}) => {
  userUuid = uuid ?? null;
  userIp = ip ?? null;
};

export const userContext = {
  get uuid() {
    return userUuid;
  },
  get ip() {
    return userIp;
  },
};
